import { render, staticRenderFns } from "./older_file.vue?vue&type=template&id=b343b306&scoped=true&"
import script from "./older_file.vue?vue&type=script&lang=js&"
export * from "./older_file.vue?vue&type=script&lang=js&"
import style0 from "./older_file.vue?vue&type=style&index=0&id=b343b306&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b343b306",
  null
  
)

export default component.exports